(() => {
    const titleContainer = document.querySelector('[data-pokemon-subcollection-mobile]');
    if (!titleContainer || titleContainer.dataset.initialized) return;
    titleContainer.dataset.initialized = 'true';
    const main = titleContainer.closest('main');
    const viewport = window.matchMedia('(max-width: 991px)');
    let heading;
    let headingPlaceholder;
    let categoryHeading;

    function update() {
        // A reloaded editor section can replace the original title position.
        if (headingPlaceholder && !headingPlaceholder.isConnected) {
            heading?.remove();
            heading = null;
            headingPlaceholder = null;
        }
        const sections = Array.from(main.children).filter(node => node.classList.contains('shopify-section'));
        const products = sections.find(section => section.querySelector('collection-products'));
        if (!products) return;
        main.classList.add('cd-pokemon-subcategory-layout');

        const categories = sections.filter(section => !section.querySelector('collection-products') && section.querySelector('.cd-pokemon-product-types, [class~="#collection-card"]'));
        sections.forEach(section => {
            section.dataset.pokemonMobileRole = section === products ? 'products' : categories.includes(section) ? 'categories' : 'information';
        });

        if (viewport.matches) {
            if (!heading || !heading.isConnected) {
                heading = sections.map(section => section.querySelector('h1')).find(Boolean);
                if (heading) {
                    headingPlaceholder = document.createComment('Collection title desktop position');
                    heading.before(headingPlaceholder);
                } else {
                    heading = document.createElement('h1');
                    heading.className = 'collection-hero__title';
                    heading.textContent = titleContainer.dataset.collectionTitle;
                    headingPlaceholder = null;
                }
            }
            if (heading.parentElement !== titleContainer) titleContainer.append(heading);

            if (categories.length && (!categoryHeading || !categoryHeading.isConnected)) {
                categoryHeading = document.createElement('h2');
                categoryHeading.className = 'cd-subcollection-mobile-categories-heading #container';
                categoryHeading.textContent = 'Weitere Pokémon-Kategorien';
                categories[0].prepend(categoryHeading);
            }
        } else {
            if (headingPlaceholder?.isConnected && heading?.parentElement === titleContainer) headingPlaceholder.after(heading);
            else if (!headingPlaceholder) heading?.remove();
        }
    }

    viewport.addEventListener('change', update);
    document.addEventListener('shopify:section:load', update);
    update();
})();
